import { EPartnerRequestStatus } from 'FeatureModules/Partner/types/partner.types';

export const REVIEW_REQUEST_BUTTON_STATUS_CLIENT: Record<
  EPartnerRequestStatus,
  { tooltip: string; disabled: boolean }
> = {
  [EPartnerRequestStatus.DELETED]: {
    tooltip: 'This chain used to be part of a deleted request',
    disabled: true,
  },
  [EPartnerRequestStatus.DENIED]: {
    tooltip: 'This chain is part of a denied request',
    disabled: true,
  },
  [EPartnerRequestStatus.DENIED_COMPLETED]: {
    tooltip: 'This chain used to be part of a denied request',
    disabled: true,
  },
  [EPartnerRequestStatus.REQUESTED]: {
    tooltip:
      'Your partner is currently working on this chain. As soon as they are done, you will be able to review it.',
    disabled: true,
  },
  [EPartnerRequestStatus.EDITED]: {
    tooltip:
      'Your partner is currently working on this chain. As soon as they are done, you will be able to review it.',
    disabled: true,
  },
  [EPartnerRequestStatus.PROVIDED]: {
    tooltip: '',
    disabled: false,
  },
  [EPartnerRequestStatus.PROVIDED_COMPLETED]: {
    tooltip: 'This chain is part of a completed request',
    disabled: true,
  },
};

export const REVIEW_REQUEST_BUTTON_STATUS_PARTNER: Record<
  EPartnerRequestStatus,
  { tooltip: string; disabled: boolean }
> = {
  [EPartnerRequestStatus.DELETED]: {
    tooltip: 'This chain used to be part of a deleted request',
    disabled: true,
  },
  [EPartnerRequestStatus.DENIED]: {
    tooltip: 'This chain is part of a denied request',
    disabled: true,
  },
  [EPartnerRequestStatus.DENIED_COMPLETED]: {
    tooltip: 'This chain used to be part of a denied request',
    disabled: true,
  },
  [EPartnerRequestStatus.REQUESTED]: {
    tooltip: '',
    disabled: false,
  },
  [EPartnerRequestStatus.EDITED]: {
    tooltip: '',
    disabled: false,
  },
  [EPartnerRequestStatus.PROVIDED]: {
    tooltip: 'This chain is currently being reviewed by your partner',
    disabled: true,
  },
  [EPartnerRequestStatus.PROVIDED_COMPLETED]: {
    tooltip: 'This chain is part of a completed request',
    disabled: true,
  },
};
